import type { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Input } from 'components/ui'
import s from './recover-password-verify.module.css'
import type { RecoverPasswordVerifyProps, RecoverPasswordVerifyRequest } from '.'

const RecoverPasswordVerify: FC<RecoverPasswordVerifyProps> = ({ onCancel, onSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touched, isSubmitting },
    reset,
    setError,
  } = useForm({
    mode: 'onChange',
  })

  const handleFormSubmit = (data: RecoverPasswordVerifyRequest) => {
    const { code } = data
    if (code.length < 6) {
      setError('code', {
        message: 'Código inválido',
      })
    } else {
      onSubmit(data)
      reset()
    }
  }

  return (
    <div className={s.root}>
      <h1 className={s.title}>Confirme o código recebido por e-mail</h1>
      <form onSubmit={handleSubmit(handleFormSubmit)} className={s.form}>
        <Input
          type="text"
          name="code"
          placeholder="Seu código"
          error={errors?.code?.message}
          touched={touched?.code}
          maxLength={6}
          disabled={isSubmitting}
          ref={register({
            required: true,
            minLength: {
              value: 5,
              message: 'Código inválido',
            },
          })}
        />

        <Button variant="primary" type="submit" loading={isSubmitting}>
          Confirmar código
        </Button>
      </form>
      <Button variant="link" onClick={onCancel}>
        Voltar
      </Button>
    </div>
  )
}

export default RecoverPasswordVerify
